import { gql } from '@apollo/client';

export const COMPLETION_CODE_CREATE = gql`
    mutation createCompletionCode( $input: CreateCompletionCodeInput! ) {
        createCompletionCode( input: $input ) {
            id
            companyId
            instructorLedTrainingId
            code
            createdAt
            deletedAt
        }
    }
`;

export default COMPLETION_CODE_CREATE;
